module.exports = __webpack_public_path__ + "static/media/mesa.4c2c68cb.png";